import React, { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import Button from "@mui/material/Button";

const HomePage = () => {
  return <div></div>;
};

export default HomePage;
